import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"minus\">\n<path d=\"M31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16Z\" stroke=\"#E8E8E8\" stroke-width=\"1\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.5385 16C21.7934 16 22 16.2239 22 16.5C22 16.7455 21.8367 16.9496 21.6214 16.9919L21.5385 17H10.4615C10.2066 17 10 16.7761 10 16.5C10 16.2545 10.1633 16.0504 10.3786 16.0081L10.4615 16H21.5385Z\" fill=\"#212121\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol